import React from 'react';


 export function Navbar(){
    return (
        <header>
            <div className="container">
              <img src={'images/logo.svg'}  alt="logo_website"/>
              <nav>
                <ul>
                    <li><a href="#features">Features</a></li>
                    <li><a href="#team">Team</a></li>
                    <li><a href="#signin">Sign In</a></li>

                </ul>
              </nav>
            </div>
        </header>
    );
}
export default Navbar;